var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.66095 5.19169L4.23502 14.6051C4.27954 15.3253 4.88909 15.9046 5.64947 15.9046H12.0391C12.7833 15.9046 13.3868 15.3492 13.452 14.6468L14.3171 5.19029C12.7343 5.08906 10.625 4.97794 8.99996 4.97794C7.36748 4.97794 5.24616 5.09009 3.66095 5.19169ZM15.7427 5.28779C15.8968 5.29902 16.0326 5.30915 16.147 5.31781C16.2794 5.32784 16.3833 5.33591 16.4538 5.34146L16.5608 5.34997C16.954 5.3819 17.299 5.08906 17.3309 4.69587C17.3628 4.30267 17.07 3.95804 16.6768 3.92611L16.5658 3.91728C16.494 3.91163 16.3888 3.90346 16.2549 3.89332C15.9871 3.87304 15.6044 3.84489 15.144 3.81336C13.5326 3.703 10.9438 3.54937 8.99996 3.54937C7.05613 3.54937 4.46727 3.703 2.85594 3.81336C2.39549 3.84489 2.0128 3.87304 1.74503 3.89332C1.61113 3.90346 1.50594 3.91163 1.43408 3.91728L1.32368 3.92607C0.930484 3.958 0.637073 4.30267 0.669004 4.69587C0.700934 5.08906 1.04556 5.38192 1.43875 5.35M1.43875 5.35L1.54609 5.34146C1.61667 5.33591 1.72048 5.32784 1.85291 5.31781C1.96198 5.30955 2.09044 5.29996 2.23569 5.28936L2.80913 14.6926C2.9012 16.1856 4.15377 17.3332 5.64947 17.3332H12.0391C13.5015 17.3332 14.7398 16.2351 14.8746 14.7779L15.7427 5.28779",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.66663 2.09508C7.53513 2.09508 7.42854 2.20168 7.42854 2.33317V3.85184C7.42854 4.24633 7.10874 4.56612 6.71425 4.56612C6.31977 4.56612 5.99997 4.24633 5.99997 3.85184V2.33317C5.99997 1.4127 6.74616 0.666504 7.66663 0.666504H10.3333C11.2538 0.666504 11.9999 1.4127 11.9999 2.33317V3.85184C11.9999 4.24633 11.6802 4.56612 11.2857 4.56612C10.8912 4.56612 10.5714 4.24633 10.5714 3.85184V2.33317C10.5714 2.20168 10.4648 2.09508 10.3333 2.09508H7.66663Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.23812 3.85185C5.23812 3.45736 5.55791 3.13757 5.9524 3.13757L7.4762 3.13757C7.87069 3.13757 8.19048 3.45736 8.19048 3.85185C8.19048 4.24634 7.87069 4.56614 7.4762 4.56614H5.9524C5.55791 4.56614 5.23812 4.24634 5.23812 3.85185Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.80946 3.85185C9.80946 3.45736 10.1293 3.13757 10.5237 3.13757H12.0475C12.442 3.13757 12.7618 3.45736 12.7618 3.85185C12.7618 4.24634 12.442 4.56614 12.0475 4.56614H10.5237C10.1293 4.56614 9.80946 4.24634 9.80946 3.85185Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.99996 7.25599C9.39445 7.25599 9.71424 7.57578 9.71424 7.97027V12.9124C9.71424 13.3069 9.39445 13.6267 8.99996 13.6267C8.60547 13.6267 8.28568 13.3069 8.28568 12.9124V7.97027C8.28568 7.57578 8.60547 7.25599 8.99996 7.25599Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.9524 8.07964C6.34689 8.07964 6.66668 8.39943 6.66668 8.79392V12.0887C6.66668 12.4831 6.34689 12.8029 5.9524 12.8029C5.55791 12.8029 5.23812 12.4831 5.23812 12.0887V8.79393C5.23812 8.39944 5.55791 8.07964 5.9524 8.07964Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0475 8.07964C12.442 8.07964 12.7618 8.39943 12.7618 8.79392V12.0887C12.7618 12.4831 12.442 12.8029 12.0475 12.8029C11.653 12.8029 11.3332 12.4831 11.3332 12.0887V8.79393C11.3332 8.39944 11.653 8.07964 12.0475 8.07964Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteWhite);
export default __webpack_public_path__ + "static/media/delete_white.b66f8214.svg";
export { ForwardRef as ReactComponent };